import React from 'react';
import { MapPin, Phone, Mail, Instagram, Facebook, Clock } from 'lucide-react';
import { restaurantInfo } from '../mockData';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer style={{ backgroundColor: 'var(--color-black)', color: 'white' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Column */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
              {restaurantInfo.name}
            </h3>
            <p className="text-gray-300 mb-4">
              Where culinary excellence meets vibrant ambiance. Experience the perfect blend of exquisite food, craft cocktails, and lively entertainment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="footer-link">About Us</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('menu')} className="footer-link">Our Menu</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="footer-link">Gallery</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('reviews')} className="footer-link">Reviews</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin size={18} className="mr-3 mt-1 flex-shrink-0" />
                <p className="text-gray-300 text-sm">{restaurantInfo.address}</p>
              </div>
              <div className="flex items-center">
                <Phone size={18} className="mr-3 flex-shrink-0" />
                <a href={`tel:${restaurantInfo.phone}`} className="text-gray-300 hover:text-white transition-colors">
                  {restaurantInfo.phone}
                </a>
              </div>
              <div className="flex items-center">
                <Mail size={18} className="mr-3 flex-shrink-0" />
                <a href={`mailto:${restaurantInfo.email}`} className="text-gray-300 hover:text-white transition-colors">
                  {restaurantInfo.email}
                </a>
              </div>
              <div className="flex items-center">
                <Clock size={18} className="mr-3 flex-shrink-0" />
                <p className="text-gray-300 text-sm">{restaurantInfo.hours}</p>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a 
                href={restaurantInfo.socialMedia.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={restaurantInfo.socialMedia.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} {restaurantInfo.name}. All rights reserved.</p>
        </div>
      </div>

      <style jsx>{`
        .footer-link {
          color: #d1d5db;
          transition: color 0.2s ease;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 14px;
          text-align: left;
          padding: 0;
        }

        .footer-link:hover {
          color: white;
        }

        .social-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease, transform 0.2s ease;
        }

        .social-icon:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }
      `}</style>
    </footer>
  );
};

export default Footer;
